export default {
    url: '/form/:guid',
    template: '<feedback-form form-submission="vm.formSubmission"/>',
    resolve: {
        formSubmission (FormSubmissionResource, $stateParams) {
            return FormSubmissionResource.get({ guid: $stateParams.guid, expand: 'form' }).$promise;
        }
    },
    controller (formSubmission, WindowConfirmService) {
        this.formSubmission = formSubmission;
        // ask confirmation if user refresh
        WindowConfirmService.activate();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/feedback/form/index.js